import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { UserService } from './user.service';

export interface ITeamProfile {
	id: string;
	alias: string;
	description: string;
	calendarId: string;
	timeZoneId: string;
	configurations: ITeamProfileConfiguration[];
}

export interface ITeamProfileConfiguration {
	alias: string;
	activeDate: string;
	weekDays: IWeekDays;
	roundingTime: number;
	endRoundingTime: number;
}

export interface IWeekDays {
	monday: IWorkDay;
	tuesday: IWorkDay;
	wednesday: IWorkDay;
	thursday: IWorkDay;
	friday: IWorkDay;
	saturday: IWorkDay;
	sunday: IWorkDay;
}

export interface IWorkDay {
	isWorkDay: boolean;
	workTime: ITimeInterval;
	variableWeeklyWorkTime: ITimeInterval;
	breaks: ITimeInterval[];
}

export interface ITimeInterval {
	startTime: string;
	endTime: string;
}

export interface ITeamProfileResponse {
	result: ITeamProfile;
}

export interface ITeamProfiles {
	result: ITeamProfile[];
}

export interface ITeamProfileConfigurationViewModel {
	configAlias: string;
	activeDate: string;
	roundingTime: number;
	endRoundingTime: number;
}

export interface IBreakViewModel {
	startTime: string;
	endTime: string;
}

interface IPostTeamProfileRequest {
	alias: string;
	description: string;
	timeZoneId: string;
	calendarId: string;
	configurations: ITeamProfileConfiguration[];
}

@Injectable({
	providedIn: 'root',
})
export class TeamProfileService {
	constructor(
		private http: HttpClient,
		private userService: UserService,
	) {}

	getTeamProfiles(): Observable<ITeamProfiles> {
		return this.http.get<ITeamProfiles>(`${environment.awsEnvUri}/mes/teamprofiles`, {
			headers: this.userService.getHeaders(),
		});
	}

	getTeamProfileByAlias(alias): Observable<ITeamProfileResponse> {
		return this.http.get<ITeamProfileResponse>(`${environment.awsEnvUri}/mes/teamprofiles/alias/${alias}`, { headers: this.userService.getHeaders() });
	}

	createTeamProfile(teamProfile: ITeamProfile): Observable<ITeamProfileResponse> {
		const body: IPostTeamProfileRequest = {
			alias: teamProfile.alias,
			timeZoneId: teamProfile.timeZoneId,
			description: teamProfile.description,
			calendarId: teamProfile.calendarId,
			configurations: teamProfile.configurations,
		};
		return this.http.post<ITeamProfileResponse>(`${environment.awsEnvUri}/mes/teamprofiles`, body, { headers: this.userService.getHeaders() });
	}

	updateTeamProfile(teamProfile: ITeamProfile): Observable<ITeamProfile> {
		const body: IPostTeamProfileRequest = {
			alias: teamProfile.alias,
			timeZoneId: teamProfile.timeZoneId,
			description: teamProfile.description,
			calendarId: teamProfile.calendarId,
			configurations: teamProfile.configurations,
		};
		return this.http.put<ITeamProfile>(`${environment.awsEnvUri}/mes/teamprofiles/${teamProfile.id}`, body, { headers: this.userService.getHeaders() });
	}
}
